export function proxyImageUrl(url: string, width: number, height: number, quality = 80): string {
    // Local static assets (deck folders under /images/...) are already
    // right-sized and — critically — unreachable from wsrv.nl: in the
    // Capacitor webview the origin is the device itself, and in production
    // the origin may sit behind auth/routing. Render them un-proxied.
    if (url.startsWith('/')) return url;
    return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${width}&h=${height}&output=webp&q=${quality}`;
}